const DEFAULT_CUSTOM_DOMAIN = 'https://lyxcrziihvhucgtftakw.supabase.co/functions/v1';

export const getApiDomain = (): string => {
  const domain = process.env.EXPO_PUBLIC_HEKAYA_CUSTOM_DOMAIN;

  if (!domain) {
    console.warn(
      '[API Config] ⚠️ EXPO_PUBLIC_HEKAYA_CUSTOM_DOMAIN is not defined. ' +
      `Using fallback: ${DEFAULT_CUSTOM_DOMAIN}`
    );
    return DEFAULT_CUSTOM_DOMAIN;
  }

  return domain;
};

export const getApiUrl = (endpoint: string): string => {
  const domain = getApiDomain();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${domain}${cleanEndpoint}`;
};

export const getSupabaseAnonKey = (): string => {
  const key = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;

  if (!key) {
    console.error('[API Config] ❌ EXPO_PUBLIC_SUPABASE_ANON_KEY is not defined!');
    throw new Error('Supabase anonymous key is required but not configured');
  }

  return key;
};

export const getSupabaseUrl = (): string => {
  const url = process.env.EXPO_PUBLIC_SUPABASE_URL;

  if (!url) {
    console.error('[API Config] ❌ EXPO_PUBLIC_SUPABASE_URL is not defined!');
    throw new Error('Supabase URL is required but not configured');
  }

  return url;
};
